// import React, { useState, useEffect } from 'react';
// import H1 from '../Images/Hma.jpeg';
// import L1 from '../Images/logo-w.png';
// import A1 from '../Images/sig.jpeg';
// import axios from 'axios';

// const FeedbackForm = () => {
//     const [name, setName] = useState('');
//     const [mobile, setMobile] = useState('');
//     const [email, setEmail] = useState('');
//     const [isMember, setIsMember] = useState('');
//     const [likedTopics, setLikedTopics] = useState('');
//     const [speakersExpectation, setSpeakersExpectation] = useState('');
//     const [attendFutureConferences, setAttendFutureConferences] = useState('');
//     const [likedTopic, setLikedTopic] = useState('');
//     const [overallFeedback, setOverallFeedback] = useState('');
//     const [isSessionActive, setIsSessionActive] = useState(false);


//     useEffect(() => {
//         fetchSessionStatus();
//     }, []);

//     const fetchSessionStatus = async () => {
//         try {
//             const response = await axios.get('https://rvapi.emedha.in/pages/api/feedbackform/sessionfb_timing');
//             console.log("Session Response:", response.data);

//             if (response.status === 200 && response.data.length > 0) {
//                 const session = response.data[0];
//                 const currentDate = new Date();
//                 const startDate = new Date(session.startDate);
//                 const endDate = new Date(session.endDate);
//                 if (currentDate >= startDate && currentDate <= endDate) {
//                     setIsSessionActive(true);
//                 } else {
//                     setIsSessionActive(false);
//                 }
//             } else {
//                 setIsSessionActive(false);
//             }
//         } catch (error) {
//             console.error('Error fetching session status:', error);
//             setIsSessionActive(false);
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const feedbackData = {
//             name,
//             mobile,
//             email,
//             isMember,
//             likedTopics,
//             speakersExpectation,
//             attendFutureConferences,
//             likedTopic,
//             overallFeedback
//         };

//         try {
//             const response = await axios.post('https://rvapi.emedha.in/pages/api/api/submit-feedback', feedbackData, {
//                 headers: {
//                     'Content-Type': 'application/json',
//                 }
//             });

//             if (response.status === 200) {
//                 alert(response.data.message);
//                 setName('');
//                 setMobile('');
//                 setEmail('');
//                 setIsMember('');
//                 setLikedTopics('');
//                 setSpeakersExpectation('');
//                 setAttendFutureConferences('');
//                 setLikedTopic('');
//                 setOverallFeedback('');
//             } else {
//                 alert('Error submitting feedback');
//             }
//         } catch (error) {
//             console.error('Error:', error);
//             if (error.response && error.response.data && error.response.data.code === "ER_DUP_ENTRY") {
//                 alert("Duplicate entry detected. Your feedback has already been submitted.");
//             } else {
//                 alert('Error submitting feedback');
//             }
//         }
//     };

//     return (
//         <>
//             <img src={H1} alt="item" style={{ height: '150px', width: '100%' }} />
//             {isSessionActive ? (
//                 <div>
//                     <form onSubmit={handleSubmit} style={{ padding: '20px', backgroundColor: '#f4f4f9', borderRadius: '8px' }}>
//                         <div className='row'>
//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Name:</label>
//                                 <input type="text" value={name} onChange={(e) => setName(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
//                             </div>

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Mobile:</label>
//                                 <input type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} maxLength={10} />
//                             </div>

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Email:</label>
//                                 <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
//                             </div>

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Are you a member of HMA?</label>
//                                 <select
//                                     value={isMember}
//                                     onChange={(e) => setIsMember(e.target.value)}
//                                     required
//                                     style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
//                                     <option value="">Select</option>
//                                     <option value="Y">Yes</option>
//                                     <option value="N">No</option>
//                                 </select>
//                             </div>

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Did you like the Topic? </label>
//                                 <select
//                                     value={likedTopics}
//                                     onChange={(e) => setLikedTopics(e.target.value)}
//                                     required
//                                     style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
//                                     <option value="">Select</option>
//                                     <option value="Y">Yes</option>
//                                     <option value="N">No</option>
//                                 </select>
//                             </div>     

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Did the Speakers deliver up to your expectation?</label>
//                                 <select
//                                     value={speakersExpectation}
//                                     onChange={(e) => setSpeakersExpectation(e.target.value)}
//                                     required
//                                     style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
//                                     <option value="">Select</option>
//                                     <option value="Y">Yes</option>
//                                     <option value="N">No</option>
//                                 </select>
//                             </div>

//                             <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Will you be attend future Seminars/Conferences</label>
//                                 <select
//                                     value={attendFutureConferences}
//                                     onChange={(e) => setAttendFutureConferences(e.target.value)}
//                                     required
//                                     style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
//                                     <option value="">Select</option>
//                                     <option value="Y">Yes</option>
//                                     <option value="N">No</option>
//                                 </select>
//                             </div>

//                             {/* <div className='col-6' style={{ marginBottom: '10px' }}>
//                                 <label>Which topic did you like the most?</label>
//                                 <input
//                                     type="text"
//                                     value={likedTopic}
//                                     onChange={(e) => setLikedTopic(e.target.value)}
//                                     required
//                                     style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}
//                                 />
//                             </div> */}
//                         </div>
//                         <div style={{ marginBottom: '10px' }}>
//                             <label>Overall Feedback:</label>
//                             <textarea
//                                 value={overallFeedback}
//                                 onChange={(e) => setOverallFeedback(e.target.value)}
//                                 required
//                                 style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
//                         </div>
//                         <button className='btn btn-primary btn-sm w-100' type="submit" >Submit</button>
//                     </form>
//                     <img src={A1} alt="item" style={{ height: '1px', width: '1%' }} />
//                 </div>
//             ) : (
//                 <div>
//                     <p style={{ color: 'red', textAlign: 'center' }}>The feedback form is not available because the session is not currently active.</p>
//                 </div>
//             )}
//             <footer style={{ backgroundColor: '#f1f1f1', padding: '10px 0', textAlign: 'center', marginTop: '20px' }}>
//                 <div>
//                     <p style={{ margin: '0', fontSize: '14px' }}>Powered by
//                         <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px' }}>
//                             EMedha Technologies
//                         </a>
//                     </p>
//                     <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
//                         <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
//                     </a>
//                 </div>
//             </footer>
//         </>
//     );
// };

// export default FeedbackForm;















import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaExclamationCircle, FaCalendarAlt } from 'react-icons/fa';

const FeedbackForm = () => {
    const { sessionId } = useParams();

    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [isMember, setIsMember] = useState('');
    const [likedTopics, setLikedTopics] = useState('');
    const [speakersExpectation, setSpeakersExpectation] = useState('');
    const [attendFutureConferences, setAttendFutureConferences] = useState('');
    const [likedTopic, setLikedTopic] = useState('');
    const [overallFeedback, setOverallFeedback] = useState('');

    // Session details
    const [sessionTopic, setSessionTopic] = useState('');
    const [isSessionActive, setIsSessionActive] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSessionStatus();
    }, [sessionId]);

    const fetchSessionStatus = async () => {
        try {
            setLoading(true);

            const response = await axios.get('https://rvapi.emedha.in/pages/api/feedbackform/sessionfb_timing');

            if (response.status === 200 && Array.isArray(response.data)) {
                const session = response.data.find(
                    s => String(s.id) === String(sessionId)
                );

                if (session) {
                    const topic =
                        session.sessionTopic ||
                        session.session_topic ||
                        session.topic ||
                        session.title ||
                        '';

                    setSessionTopic(topic);

                    const currentDate = new Date();
                    const startDate = new Date(session.startDate);
                    const endDate = new Date(session.endDate);

                    if (
                        currentDate >= startDate &&
                        currentDate <= endDate
                    ) {
                        setIsSessionActive(true);
                    } else {
                        setIsSessionActive(false);
                    }
                } else {
                    setSessionTopic('');
                    setIsSessionActive(false);
                }
            } else {
                setSessionTopic('');
                setIsSessionActive(false);
            }
        } catch (error) {
            console.error('Error fetching session status:', error);
            setSessionTopic('');
            setIsSessionActive(false);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!sessionId || !sessionTopic) {
            alert('Session information is missing.');
            return;
        }

        const feedbackData = {
            session_id: sessionId,
            session_topic: sessionTopic,
            name,
            mobile,
            email,
            isMember,
            likedTopics,
            speakersExpectation,
            attendFutureConferences,
            likedTopic,
            overallFeedback
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api/submit-feedback',
                feedbackData,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.status === 200) {
                alert(response.data.message || 'Feedback submitted successfully!');

                setName('');
                setMobile('');
                setEmail('');
                setIsMember('');
                setLikedTopics('');
                setSpeakersExpectation('');
                setAttendFutureConferences('');
                setLikedTopic('');
                setOverallFeedback('');
            } else {
                alert('Error submitting feedback');
            }
        } catch (error) {
            console.error('Error:', error);
            if (error.response?.status === 409) {
                alert(error.response.data?.message || 'You have already submitted feedback for this session.');
            } else {
                alert(error.response?.data?.message || 'Error submitting feedback');
            }
        }
    };

    return (
        <div className="feedback-page">

            {/* ================= HERO SECTION (IMAGE ONLY) ================= */}
            <section className="hero-section">
                <img
                    src={H1}
                    alt="EMedha Banner"
                    className="hero-image img-fluid"
                />
            </section>

            {/* ================= MAIN CONTENT ================= */}
            <main className="feedback-content">
                <div className="container px-3 px-md-4">
                    {loading ? (
                        <div className="text-center py-5">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                            <p className="mt-3 text-muted">
                                Checking session status...
                            </p>
                        </div>
                    ) : isSessionActive ? (
                        <div className="feedback-card-wrapper">

                            {/* SESSION INFO */}
                            <div className="session-info-card">
                                <div className="session-info-icon">
                                    <FaCalendarAlt />
                                </div>
                                <div>
                                    <small>Current Session</small>
                                    <strong>{sessionTopic || 'Session Feedback'}</strong>
                                    <span>Session ID: {sessionId}</span>
                                </div>
                            </div>

                            {/* FORM */}
                            <form
                                onSubmit={handleSubmit}
                                className="feedback-form-card"
                            >
                                <div className="form-section-title">
                                    <h3>Attendee Information</h3>
                                    <p>Please provide your contact and affiliation details</p>
                                </div>

                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Full Name *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                            placeholder="Enter your full name"
                                        />
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Mobile Number *</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={mobile}
                                            onChange={(e) =>
                                                setMobile(e.target.value.replace(/\D/g, ''))
                                            }
                                            required
                                            maxLength={10}
                                            placeholder="Enter 10-digit mobile number"
                                        />
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Email Address *</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            placeholder="Enter your email address"
                                        />
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Are you a member of HMA? *</label>
                                        <select
                                            className="form-select"
                                            value={isMember}
                                            onChange={(e) => setIsMember(e.target.value)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </select>
                                    </div>
                                </div>

                                <hr className="my-4" />

                                <div className="form-section-title">
                                    <h3>Session Evaluation</h3>
                                    <p>Rate your experience with the content and speakers</p>
                                </div>

                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Did you like the Topic? *</label>
                                        <select
                                            className="form-select"
                                            value={likedTopics}
                                            onChange={(e) => setLikedTopics(e.target.value)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </select>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <label className="form-label">Did the Speakers deliver up to your expectation? *</label>
                                        <select
                                            className="form-select"
                                            value={speakersExpectation}
                                            onChange={(e) => setSpeakersExpectation(e.target.value)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </select>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Will you attend future Seminars/Conferences? *</label>
                                        <select
                                            className="form-select"
                                            value={attendFutureConferences}
                                            onChange={(e) => setAttendFutureConferences(e.target.value)}
                                            required
                                        >
                                            <option value="">Select an option</option>
                                            <option value="Y">Yes</option>
                                            <option value="N">No</option>
                                        </select>
                                    </div>

                                    <div className="col-12">
                                        <label className="form-label">Overall Feedback & Comments *</label>
                                        <textarea
                                            className="form-control"
                                            rows="4"
                                            value={overallFeedback}
                                            onChange={(e) => setOverallFeedback(e.target.value)}
                                            required
                                            placeholder="Write your feedback here..."
                                        />
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <button
                                        className="btn btn-primary w-100 py-3 submit-btn"
                                        type="submit"
                                    >
                                        Submit Feedback
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <div className="alert-card text-center">
                            <FaExclamationCircle className="alert-icon text-danger mb-3" />
                            <h3>Session Inactive</h3>
                            <p className="text-muted">
                                The feedback form is currently unavailable because the session is not active or has expired.
                            </p>
                        </div>
                    )}
                </div>
            </main>

            {/* ================= FOOTER ================= */}
            <footer className="feedback-footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-brand">
                            <a
                                href="https://emedha.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={L1}
                                    alt="EMedha Technologies Logo"
                                />
                            </a>
                        </div>
                        <div className="footer-text">
                            <p>
                                Powered by{' '}
                                <a
                                    href="https://emedha.com/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    EMedha Technologies
                                </a>
                            </p>
                            <span>
                                © {new Date().getFullYear()} EMedha Technologies. All rights reserved.
                            </span>
                        </div>
                    </div>
                </div>
            </footer>

            {/* ================= STYLES ================= */}
            <style>{`
                * {
                    box-sizing: border-box;
                }

                .feedback-page {
                    min-height: 100vh;
                    display: flex;
                    flex-direction: column;
                    background: #f8fafc;
                    color: #1e293b;
                }

                /* HERO (IMAGE ONLY) */
                .hero-section {
                    width: 100%;
                    background: #0f172a;
                    overflow: hidden;
                }

                .hero-image {
                    width: 100%;
                    max-height: 260px;
                    object-fit: cover;
                    display: block;
                }

                /* CONTENT */
                .feedback-content {
                    flex: 1;
                    padding: 30px 0 50px;
                }

                .feedback-card-wrapper {
                    max-width: 850px;
                    margin: 0 auto;
                }

                /* SESSION INFO */
                .session-info-card {
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    background: #eff6ff;
                    border: 1px solid #bfdbfe;
                    border-radius: 14px;
                    padding: 15px 18px;
                    margin-bottom: 18px;
                }

                .session-info-icon {
                    flex-shrink: 0;
                    width: 45px;
                    height: 45px;
                    border-radius: 11px;
                    background: #dbeafe;
                    color: #2563eb;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 18px;
                }

                .session-info-card div:last-child {
                    display: flex;
                    flex-direction: column;
                    min-width: 0;
                }

                .session-info-card small {
                    font-size: 11px;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .session-info-card strong {
                    font-size: 15px;
                    color: #1e3a8a;
                    margin-top: 2px;
                    word-break: break-word;
                }

                .session-info-card span {
                    font-size: 11px;
                    color: #64748b;
                    margin-top: 2px;
                }

                /* FORM */
                .feedback-form-card {
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 16px;
                    padding: 35px;
                    box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
                }

                .form-section-title h3 {
                    font-size: 18px;
                    font-weight: 700;
                    color: #0f172a;
                    margin: 0 0 4px;
                }

                .form-section-title p {
                    font-size: 13px;
                    color: #64748b;
                    margin: 0 0 20px;
                }

                .form-label {
                    font-size: 13px;
                    font-weight: 600;
                    color: #334155;
                    margin-bottom: 6px;
                }

                .form-control,
                .form-select {
                    padding: 10px 14px;
                    border-radius: 10px;
                    border: 1px solid #cbd5e1;
                    font-size: 14px;
                    color: #1e293b;
                }

                .form-control:focus,
                .form-select:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
                }

                .submit-btn {
                    background: linear-gradient(135deg, #2563eb, #4f46e5);
                    border: none;
                    border-radius: 12px;
                    font-weight: 600;
                    font-size: 15px;
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
                }

                .submit-btn:hover {
                    background: linear-gradient(135deg, #1d4ed8, #4338ca);
                }

                /* ALERT */
                .alert-card {
                    max-width: 550px;
                    margin: 40px auto;
                    background: white;
                    border: 1px solid #e2e8f0;
                    border-radius: 16px;
                    padding: 40px 25px;
                    box-shadow: 0 4px 20px rgba(15, 23, 42, 0.05);
                }

                .alert-icon {
                    font-size: 45px;
                }

                .alert-card h3 {
                    font-size: 20px;
                    font-weight: 700;
                }

                /* FOOTER */
                .feedback-footer {
                    background: white;
                    border-top: 1px solid #e2e8f0;
                    padding: 20px 0;
                }

                .footer-content {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 18px;
                    text-align: left;
                }

                .footer-brand img {
                    width: 145px;
                    max-width: 100%;
                    height: auto;
                }

                .footer-text p {
                    margin: 0 0 3px;
                    color: #64748b;
                    font-size: 13px;
                }

                .footer-text p a {
                    color: #2563eb;
                    text-decoration: none;
                    font-weight: 600;
                }

                .footer-text span {
                    color: #94a3b8;
                    font-size: 11px;
                }

                /* MOBILE OPTIMIZATIONS */
                @media (max-width: 768px) {
                    .hero-image {
                        max-height: 150px;
                    }

                    .feedback-content {
                        padding: 15px 10px 30px;
                    }

                    .feedback-form-card {
                        padding: 20px 15px;
                        border-radius: 12px;
                    }

                    .session-info-card {
                        padding: 12px 14px;
                        border-radius: 10px;
                    }

                    .footer-content {
                        flex-direction: column;
                        text-align: center;
                    }
                }
            `}</style>
        </div>
    );
};

export default FeedbackForm;